import { Box, HStack, Icon, Image, Text, VStack } from "@chakra-ui/react";
import { RiInstanceLine } from "@remixicon/react";
import { useNavigate } from "react-router-dom";
import { BlogInterface } from "../../constants/Blog";
import { useBgHover } from "../../themes/colors";
import { formatDate } from "../../utils/helperFunction";

interface CategorizedVerticalBlogCardProps {
  data: BlogInterface | undefined;
}

const CategorizedVerticalBlogCard = ({
  data,
  ...rest
}: CategorizedVerticalBlogCardProps) => {
  const navigate = useNavigate();
  const bgHover = useBgHover();

  const goToDetail = () => {
    navigate(`/blog/${data?.slug}`);
  };

  return (
    <Box
      borderRadius={"md"}
      cursor={"pointer"}
      onClick={goToDetail}
      _hover={{ bg: bgHover }}
    >
      <Image
        src={
          data?.thumbnail
            ? `${process.env.REACT_APP_MEDIA_URL}${data?.thumbnail}`
            : ""
        }
        fallbackSrc="/assets/svg/illustration_empty.svg"
        alt={data?.title || "Image"}
        width="full"
        aspectRatio={"2/1"}
        objectFit="cover"
        borderRadius="md"
      />
      <VStack align={"start"} mt={"16px"} px={"12px"}>
        <HStack>
          <Icon as={RiInstanceLine} />

          <Text
            textStyle="b-sm"
            textTransform={"uppercase"}
            variant={"secondary"}
          >
            {data?.category_name}
          </Text>
        </HStack>

        <Text textStyle={"b-reg-sb"} noOfLines={2} lineHeight={"16px"}>
          {data?.title}
        </Text>

        <Text
          textStyle={"b-sm"}
          variant={"secondary"}
          noOfLines={3}
          textOverflow={"ellipsis"}
          lineHeight={"14px"}
        >
          {data?.preview}
        </Text>

        {data?.posted_date && (
          <Text
            textStyle="b-sm"
            variant={"secondary"}
            noOfLines={1}
            textOverflow={"ellipsis"}
          >
            {formatDate(data?.posted_date)}
          </Text>
        )}
      </VStack>
    </Box>
  );
};

export default CategorizedVerticalBlogCard;
